<template>
  <div>
    <div class="modal-box">
      <header class="modal-card-head is-flex flex-wrap">
        <span class="modal-card-title is-size-7-touch">Are you sure you want to ban {{ member.name }} ?</span>
      </header>
      <section class="modal-card-body">
        <div class="field">
          <label class="label">State the Reason</label>
          <p class="control">
            <input
              v-model="reason"
              class="input"
              type="text"
              placeholder="Reason"
            >
          </p>
        </div>

        <div class="field">
          <label class="label">Duration</label>
          <p class="control">
            <v-select
              v-model="duration"
              :options="durationOptions"
            />
          </p>
        </div>
      </section>
      <footer class="modal-card-foot">
        <button
          class="button is-danger"
          @click.prevent="ban"
        >
          Ban Player
        </button>
        <button
          class="button"
          @click.prevent="close"
        >
          Cancel
        </button>
      </footer>
    </div>
  </div>
</template>
<style scoped lang="less">
  .v-select.single.open .selected-tag {
    position: relative !important;
  }
  .v-select {
    z-index:9999;
  }
  .modal-card-body {
    overflow: inherit !important;
  }
</style>

<script>
  import vSelect from 'vue-select'
  import moment from 'moment'
  export default {
    components: {
      'v-select': vSelect,
    },
    props: ['member'],
    data () {
      return {
        durationOptions: [
          {label: '1 Week', value: 168},
          {label: '2 Weeks', value: 336},
          {label: '1 Month', value: 730.001},
          {label: '3 Months', value: 2190},
          {label: '6 Months', value: 4380},
          {label: '1 Year', value: 8760.01},
          {label: 'Lifetime', value: 876000}
        ],
        reason: '',
        duration: '',
        valid: true
      }
    },
    methods: {
      ban () {
        let payload = {
          ahlid: this.member.ahlid,
          reason: this.reason,
          duration: this.duration.value
        }
        payload.duration = moment().add(this.duration.value, 'hours').format('YYYY-MM-DD HH:mm:ss')
        this.$emit('banMember', payload)
      },
      close () {
        this.$emit('close')
      }
    }
  }
</script>
